// General
import React, { Component } from 'react';
// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import {
  Modal
} from 'react-bootstrap';
// Redux
import { connect } from 'react-redux';
// Component
import AdminRolesForm from '../AdminRolesForm';

import { closeAdminRolesModal } from '../../../actions/siteadmin/modalActions';
import messages from '../../../locale/messages';
import s from './AdminRolesModal.css';

class AdminRolesModal extends Component {
  static defaultProps = {
    adminRolesModalType: 'add'
  };
  constructor(props) {
    super(props);
  }
  render() {
    const { closeAdminRolesModal, adminRolesModal, adminRolesModalType, paginationData, currentPage } = this.props;
    return (
      <>
        <Modal show={adminRolesModal} onHide={closeAdminRolesModal} dialogClassName='commonModalContainer' >
          <Modal.Header closeButton className='commonModalHeader'>
            <Modal.Title>
              <div className="commonModalTitle">
                <FormattedMessage {...messages[adminRolesModalType === 'add' ? 'addAdminRole' : 'editAdminRole']} />
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className='commonModalBody'>
            <AdminRolesForm paginationData={paginationData} currentPage={currentPage} />
          </Modal.Body>
        </Modal>
      </>
    )
  }
}
const mapState = (state) => ({
  adminRolesModal: state.adminModalStatus.adminRolesModal,
  adminRolesModalType: state.adminModalStatus.adminRolesModalType
});
const mapDispatch = {
  closeAdminRolesModal
};
export default withStyles(s)(connect(mapState, mapDispatch)(AdminRolesModal));
